import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmed: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(11),
    },

    unconfirmed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(11),
    },

    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      padding: 0,
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '0px 32px 24px',
    },

    userList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    userListItem: {
      width: '40%',
      padding: '0 4px 8px 0',
    },

    loadingContainer: {
      minHeight: '100px',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    primary: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const listItemsStyles = makeStyles(() => {
  return {
    root: {
      minWidth: '50px',
      wordBreak: 'break-all',
      textAlign: 'end',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
      borderBottom: '0 !important',
    },
    refreshButton: {
      fontWeight: '500 !important',
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(14),
      textTransform: 'Capitalize',
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles, customCardStyles };
